var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-pages-hero-editing web-pages-editing-block"},[_c('div',{staticClass:"web-pages-universal-fields"},[_c('div',{staticClass:"form-input"},[_c('label',[_vm._v("Order of list")]),_c('input',{attrs:{"type":"number","placeholder":"1, 2, 3, 4 or 5"},domProps:{"value":_vm.selectedBlock.position},on:{"input":function($event){return _vm.$store.dispatch('webPages/handleBlockInput', {
            key: 'position',
            type: 'number',
            value: $event.target.value,
          })}}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }